<template>
  <div class="log-time-form">
    <div class="log-time-form__inputs">
      <div class="log-time-input-group">
        <label class="log-time-input-group__label">Uren</label>
        <input
          type="number"
          v-model.number="form.hours"
          min="0"
          max="24"
          class="log-time-input-group__input"
        />
      </div>
      <div class="log-time-input-group">
        <label class="log-time-input-group__label">Minuten</label>
        <input
          type="number"
          v-model.number="form.minutes"
          min="0"
          max="59"
          step="5"
          class="log-time-input-group__input"
        />
      </div>
    </div>

    <TextAreaInput
      id="log_time_notes"
      label="Notities (optioneel)"
      v-model="form.notes"
      :rows="2"
    />

    <div class="log-time-form__actions">
      <Btn variant="tertiary" @click="handleCancel">Annuleren</Btn>
      <Btn variant="secondary" @click="handleSubmit" :loading="loading">Opslaan</Btn>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue';
  import Btn from '@/components/partials/Btn.vue';
  import TextAreaInput from '@/components/inputs/TextAreaInput.vue';

  export default defineComponent({
    name: 'LogTimeModal',

    components: {
      Btn,
      TextAreaInput,
    },

    props: {
      activity: {
        type: Object,
        required: true,
      },
      onSubmit: {
        type: Function,
        required: true,
      },
      onCancel: {
        type: Function,
        default: () => {},
      },
      modalId: {
        type: [String, Number],
        default: null,
      },
    },

    setup(props) {
      const loading = ref(false);

      const form = ref({
        hours: Math.floor((props.activity.logged_minutes || 0) / 60),
        minutes: (props.activity.logged_minutes || 0) % 60,
        notes: props.activity.notes || '',
      });

      const handleCancel = () => {
        props.onCancel();
      };

      const handleSubmit = async () => {
        loading.value = true;
        try {
          await props.onSubmit({
            logged_minutes: form.value.hours * 60 + form.value.minutes,
            notes: form.value.notes,
          });
        } finally {
          loading.value = false;
        }
      };

      return {
        form,
        loading,
        handleCancel,
        handleSubmit,
      };
    },
  });
</script>

<style scoped lang="scss">
  .log-time-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &__inputs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }

    &__actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      padding-top: 0.5rem;
      border-top: 1px solid var(--slate-200);
    }
  }

  .log-time-input-group {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;

    &__label {
      font-size: 0.875rem;
      font-weight: 500;
      color: var(--slate-700);
    }

    &__input {
      width: 100%;
      padding: 0.5rem 0.75rem;
      border: 1px solid var(--slate-300);
      border-radius: 0.375rem;
      font-size: 1rem;
      color: var(--slate-900);
      background: white;

      &:focus {
        outline: none;
        border-color: var(--brand-400);
        box-shadow: 0 0 0 3px rgba(var(--brand-500-rgb), 0.1);
      }
    }
  }
</style>
